import { DependencyList, useEffect, useRef } from 'react';

export const useDynamic = <T>(factory: () => T, deps: DependencyList): T => {
    const value = useRef<T>();
    useEffect(() => {
        value.current = factory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return value.current as T;
};
